<template>

  <v-row>
    <v-col cols="12">
      <ServerSideResult :test="done" />
    </v-col>
  </v-row>

</template>

<script>
import lookups from '@/mixins/lookups';

import ServerSideResult from "@/components/ServerSideResult";

export default {

  components: { ServerSideResult },

  props: ['parameters'],

  data() {
    return {
      done: undefined
    }
  },

  watch: {
    done(to) {
      if (to) {
        this.$emit('done', to);
      }
    }
  },

  mounted() {
    let recipient = 'safe';
    if (this.parameters.target=='consultant') {
      recipient = this.parameters.recipient.id;
    }
    this.remoteLookup('ultimateTzWalletSend', {
      recipient_id: recipient,
      cash: this.parameters.cash,
    }).then( done => this.done = true ).catch(e => this.done = null);
  },

  mixins: [lookups],

}
</script>
